export const  TRANSMITTER_FIELD = {
    "transmitterModelNum" : 'label.gb.tranmsitter_model',
    "snoozeUntilDate" : 'label.gb.snooze_threshold_until',
    "transmitterSerialNum": 'label.gb.trans_serial_no'
}